import { useState } from 'react'
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch } from 'react-redux'
import { setNotification } from '../../../../Redux/Reducers/notificationHandling'

const formatApiMessage = (message) => {
  if (!message) return 'Failed'
  if (typeof message === 'string') return message
  if (typeof message === 'object') {
    return Object.values(message).flat().join(' ')
  }
  return 'Failed'
}

const ChangeSequenceButton = ({ item, onDone }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [sequence, setSequence] = useState(item?.code_sequence || 1)
  const [resend, setResend] = useState(false)
  const [loading, setLoading] = useState(false)

  if (!item?.is_automatic) return null

  const canChange = item?.is_planned_block || item?.can_change_sequence !== false
  const hasLockId = !!item?.block_group_dynamic_id

  const openModal = () => {
    if (!hasLockId) {
      dispatch(setNotification({ type: 'error', message: 'Please add a Lock ID' }))
      return
    }
    if (!canChange) {
      dispatch(
        setNotification({
          type: 'error',
          message: item?.mutation_blocked_message || 'Cannot change the code until the code issue date has passed, or after the year close date.',
        })
      )
      return
    }
    setSequence(item?.code_sequence || 1)
    setResend(!!item?.is_sold)
    setOpen(true)
  }

  const save = () => {
    const seq = parseInt(sequence, 10)
    if (!seq || seq < 1 || seq > 50) {
      dispatch(setNotification({ type: 'error', message: 'Sequence must be between 1 and 50' }))
      return
    }
    setLoading(true)
    request('automatic-codes/update', 'POST', {
      item_id: item.id,
      code_sequence: seq,
      resend_email: resend,
      is_planned_block: !!item?.is_planned_block,
    }).then((res) => {
      setLoading(false)
      if (res?.status === 200) {
        setOpen(false)
        dispatch(setNotification({ type: 'success', message: 'Sequence updated' }))
        onDone?.()
      } else {
        dispatch(setNotification({ type: 'error', message: formatApiMessage(res?.data?.message) }))
      }
    })
  }

  if (!canChange) {
    return (
      <span className='text-muted ml-1' title={item?.mutation_blocked_message || 'Code changes are blocked until issue date, or after year close'} style={{ fontSize: '0.75rem' }}>
        —
      </span>
    )
  }

  return (
    <>
      <Button size='sm' className='ml-1' style={{ background: primary_color, border: 'none' }} onClick={openModal}>
        Change sequence
      </Button>
      <Modal isOpen={open} toggle={() => setOpen(false)} centered style={{ boxShadow: 'none' }}>
        <ModalHeader toggle={() => setOpen(false)}>Change sequence</ModalHeader>
        <ModalBody>
          <label className='subtitle1'>Sequence (1–50)</label>
          <Input type='number' min={1} max={50} value={sequence} onChange={(e) => setSequence(e.target.value)} />
          {item?.is_sold ? (
            <div className='mt-3'>
              <div className='subtitle1 mb-1'>Locker has been sold. Re-issue confirmation email with the new code?</div>
              <label className='d-block'>
                <input type='radio' checked={resend} onChange={() => setResend(true)} /> Re Issue Confirmation Email with New Code
              </label>
              <label className='d-block'>
                <input type='radio' checked={!resend} onChange={() => setResend(false)} /> Do Not reissue Confirmation email
              </label>
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button color='primary' style={{ background: primary_color, border: 'none' }} disabled={loading} onClick={save}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ChangeSequenceButton
